module.exports = __webpack_public_path__ + "media/src/images/logos/mass-media/times-6c91ecf49a480124d0946f7d0a6b0bed.png";